import { QuestionPlanShortStayParams as Question } from "@/components/features/items/edit/plan/_shared/ui/components/stay-length/short-stay-params";

import { usePlanShortStayParams } from "./hooks";

export const QuestionPlanShortStayParams = () => {
	const { shortStayParams, onSetShortStayParams } = usePlanShortStayParams();

	return <Question shortStayParams={shortStayParams} onSetShortStayParams={onSetShortStayParams} />;
};

QuestionPlanShortStayParams.displayName = "QuestionPlanShortStayParams";
